import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';

export const MainLayout = (props: any) => {
  const { user } = useAuth();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Stack
      direction='column'
      minHeight='100vh'
      width='100%'
    >
      <Header user={user} />
      <Stack
        direction='row'
        spacing={2}
        width='100%'
        sx={{
          pt: '64px', // Отступ для фиксированного Header
        }}
      >
        {isDesktop && <Sidebar variant='permanent' />}
        <Stack
          p={2}
          width='100%'
        >
          {props.children}
        </Stack>
      </Stack>

      <Footer />
    </Stack>
  );
};
